import { atom } from 'jotai';

/**
 * Open/close state for the inbox right sidebar panel.
 *
 * Lifted to an atom so the panel can be toggled from the chat header (or later
 * from a message anchor) without prop drilling. Open by default.
 */
export const inboxSidebarOpenAtom = atom<boolean>(true);
